import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=78a62e14&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=78a62e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a62e14",
  null
  
)

export default component.exports